module.exports = __webpack_public_path__ + "img/misc@3x.da933ea.png";